import { FC } from "react";
import * as _ from "lodash";
import { useDeepCompareMemo } from "use-deep-compare";

import { Row } from "@ctra/components";
import { ChartType } from "@ctra/api";
import { classname } from "@ctra/utils";
import { useChartContext } from "@ctra/charts";

import { AnomalyToggle } from "../AnomalyToggle";
import styles from "./ChartFooter.module.less";

/**
 * Chart footer with anomaly view switch
 * @return {JSX.Element}
 * @constructor
 */
export const ChartFooter: FC = () => {
  const {
    values: { meta }
  } = useChartContext();

  /**
   * Assume there is missing data or anomaly if any of the meta items has it
   */
  const { hasAnomaly, hasMissingData } = useDeepCompareMemo(() => {
    return {
      hasAnomaly: _.some(meta, (item) => !!item?.hasAnomaly),
      hasMissingData: _.some(meta, (item) => !!item?.hasMissingData)
    };
  }, [meta]);

  return (hasAnomaly || hasMissingData) && _.isEqual(meta.type, ChartType.basicLine) ? (
    <Row className={classname("ctra-anomaly-toggle", styles.Wrapper)}>
      <AnomalyToggle />
    </Row>
  ) : null;
};
